import { render, staticRenderFns } from "./content-image-info.vue?vue&type=template&id=120ae4a7&scoped=true"
import script from "./content-image-info.vue?vue&type=script&lang=js"
export * from "./content-image-info.vue?vue&type=script&lang=js"
import style0 from "./content-image-info.vue?vue&type=style&index=0&id=120ae4a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120ae4a7",
  null
  
)

export default component.exports